export default __webpack_public_path__ + "static/media/EzeelinkHeadOffice.f782f944.svg";